import styled from "styled-components";

export const SidebarWrapper = styled.aside`
  width: 220px;
  min-width: 220px;
  background: var(--sidebar-bg, #fff);
  border-right: 1px solid var(--border-color, #e0e0e0);
  padding: 24px 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
  height: calc(100vh - 57px);
  position: sticky;
  top: 57px;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const SidebarLink = styled.div<{ active?: boolean }>`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 20px;
  font-size: 14px;
  color: ${({ active }) => (active ? "#1976d2" : "var(--text-primary, #333)")};
  background: ${({ active }) => (active ? "#e3f2fd" : "transparent")};
  cursor: pointer;
  transition: background 0.15s;
  font-weight: ${({ active }) => (active ? 600 : 400)};
  border-left: 3px solid ${({ active }) => (active ? "#1976d2" : "transparent")};

  &:hover {
    background: ${({ active }) => (active ? "#e3f2fd" : "var(--bg-hover, #f5f5f5)")};
  }

  svg {
    width: 20px;
    height: 20px;
    flex-shrink: 0;
  }

  a {
    color: inherit;
    text-decoration: none;
    display: flex;
    align-items: center;
    gap: 12px;
    width: 100%;
  }
`;

export const SidebarSection = styled.div`
  padding: 16px 20px 8px;
  font-size: 11px;
  font-weight: 600;
  color: #999;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const LayoutWithSidebar = styled.div`
  display: flex;
  min-height: calc(100vh - 57px);
`;

export const MainContent = styled.div`
  flex: 1;
  min-width: 0;
`;
